// jquery
//var $ = require('jquery');


import Swiper from 'swiper/bundle'; // 全ての機能が入っている

$(document).ready(function() {
  $('.drawer').drawer();
  
  $(".drawer-nav a").on("click", function() {
      $("body").removeClass("drawer-open");
  });
  console.log("hello");

});

$(function() {
  "use strict";
  
});

// function switchLanguage(language, redirectUrl) {
//   setLanguageCookie(language);
//   window.location.href = redirectUrl;
// }

// function setLanguageCookie(language) {
//   var expiryDate = new Date();
//   expiryDate.setTime(expiryDate.getTime() + (1 * 24 * 60 * 60 * 1000)); // 1日間の有効期限を設定
//   var expires = 'expires=' + expiryDate.toUTCString();
//   document.cookie = 'language=' + language + '; ' + expires + '; path=/';
// }


//サムネイル
var sliderThumbnail = new Swiper('.slider-thumbnail', {
  slidesPerColumnFill: 'column',
	slidesPerColumn: 4,
	slidesPerView: 2,
	//slidesPerGroup: 8,
  
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  pagination: {
    el: '#pagination-container-thumbnail',
    clickable: true,
  },
  navigation: {
    nextEl: '#thumbnail-next',
    prevEl: '#thumbnail-prev',
  },
});

var mySwiper = new Swiper ('.swiper-property', {
  loop: true,
  speed: 6000,
  slidesPerView:1,
  direction: 'horizontal', 
  effect: "fade",
  autoplay: {
    delay: 1000,
    stopOnLast: false,
    disableOnInteraction: true 
  },
  pagination: {
    el: '#pagination-container',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: sliderThumbnail
  },
});


$(".openbtn").click(function () {//ボタンがクリックされたら
	  $(this).toggleClass('active');//ボタン自身に activeクラスを付与し
    $("#g-nav").toggleClass('panelactive');//ナビゲーションにpanelactiveクラスを付与
    $("body").toggleClass('panelactive');//ナビゲーションにpanelactiveクラスを付与
});

$("#g-nav a").click(function () {//ナビゲーションのリンクがクリックされたら
    $(".openbtn").removeClass('active');//ボタンの activeクラスを除去し
    $("#g-nav").removeClass('panelactive');//ナビゲーションのpanelactiveクラスも除去
    $("body").removeClass('panelactive');//ナビゲーションのpanelactiveクラスも除去
});

window.onload = function() {
  // #page-topをクリックした際の設定
  $('#page-top').click(function () {
      $('body,html').animate({
          scrollTop: 0//ページトップまでスクロール
      }, 500);//ページトップスクロールの速さ。数字が大きいほど遅くなる
      return false;//リンク自体の無効化
  });
};

window.onload = function() {
  //スクロールした際の動きを関数でまとめる
  function PageTopAnime() {

    var scroll = $(window).scrollTop(); //スクロール値を取得
    if (scroll >= 200){//200pxスクロールしたら
        $('#page-top').removeClass('DownMove');   // DownMoveというクラス名を除去して
        $('#page-top').addClass('UpMove');      // UpMoveというクラス名を追加して出現
        $('#cart_link').removeClass('DownMove');   // DownMoveというクラス名を除去して
        $('#cart_link').addClass('UpMove');      // UpMoveというクラス名を追加して出現
    }else{//それ以外は
        if($('#page-top').hasClass('UpMove')){//UpMoveというクラス名が既に付与されていたら
            $('#page-top').removeClass('UpMove'); //  UpMoveというクラス名を除去し
            $('#page-top').addClass('DownMove');  // DownMoveというクラス名を追加して非表示
        }
        if($('#cart_link').hasClass('UpMove')){//UpMoveというクラス名が既に付与されていたら
            $('#cart_link').removeClass('UpMove'); //  UpMoveというクラス名を除去し
            $('#cart_link').addClass('DownMove');  // DownMoveというクラス名を追加して非表示
        }
    }
    
    var wH = window.innerHeight; //画面の高さを取得
    var footerPos =  $('#footer').offset().bottom; //footerの位置を取得
    if(scroll+wH >= (footerPos+10)) {
    var pos = (scroll+wH) - footerPos+10 //スクロールの値＋画面の高さからfooterの位置＋10pxを引いた場所を取得し
    $('#page-top').css('bottom',pos); //#page-topに上記の値をCSSのbottomに直接指定してフッター手前で止まるようにする
    }else{//それ以外は
    if($('#page-top').hasClass('UpMove')){//UpMoveというクラス名がついていたら
        $('#page-top').css('bottom','10px');// 下から10pxの位置にページリンクを指定
    }
    }
  }
  
  // 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
  PageTopAnime();/* スクロールした際の動きの関数を呼ぶ*/
  });

  // ページが読み込まれたらすぐに動かしたい場合の記述
  $(window).on('load', function () {
  PageTopAnime();/* スクロールした際の動きの関数を呼ぶ*/
  });
  // #page-topをクリックした際の設定
  $('#page-top').click(function () {
      $('body,html').animate({
          scrollTop: 0//ページトップまでスクロール
      }, 500);//ページトップスクロールの速さ。数字が大きいほど遅くなる
      return false;//リンク自体の無効化
  });
};

document.addEventListener('DOMContentLoaded', function() {
  function startHeadlineAnimation(slide) {
    var activeHeadlines = slide.querySelectorAll('.headline');
  
    activeHeadlines.forEach(function(headline) {
      if (!headline.classList.contains('headline-visible')) {
        headline.classList.add('headline-visible');
        startHeadlineAnimation(headline);
      }
    });
  }
  
  function startAnimationOnSlideChange(swiper) {
    var activeSlide = swiper.slides[swiper.activeIndex];
    startHeadlineAnimation(activeSlide);
  }

  var swiper = new Swiper('.swiper-container', {
    loop: true,
    speed: 2000,
    slidesPerView:1,
    direction: 'horizontal', 
    effect: "fade",
    observer: true,
    observeParents: true,
    autoplay: {
      delay: 7000,
      stopOnLast: false,
      disableOnInteraction: true 
    },
    pagination: {
      el: '#pagination-container',
      clickable: true,
    },
    on: {
      init: function() {
        startAnimationOnSlideChange(this);
      },
      slideChange: function() {
        startAnimationOnSlideChange(this);
      }
    }
  });

  var headlines = document.querySelectorAll('.headline');

  function startHeadlineAnimation(headline) {
      var text = headline.innerText;
      headline.innerText = '';

      // 帯の表示
      var bar = document.createElement('div');
      bar.classList.add('bar');
      var delay = parseFloat(headline.getAttribute('data-delay') || 0);
      bar.style.animationDelay = delay + 's';
      headline.appendChild(bar);

      // 文章の表示
      var letters = text.split('');
      letters.forEach(function(letter, index) {
          var span = document.createElement('span');
          span.innerText = letter;
          span.style.animationDelay = ((index * 0.1) + delay) + 's';
          span.style.opacity = '0'; // 初期状態で透明にする
          span.classList.add('headline-animation');
          span.style.animationName = 'fadein';
          headline.appendChild(span);
      });

      // 文章のフェードイン
      setTimeout(function() {
          headline.style.opacity = '1'; // .headlineをフェードイン
      }, delay * 1000); // 遅延時間後にフェードイン
  }

  function checkVisibility() {
      headlines.forEach(function(headline) {
          var rect = headline.getBoundingClientRect();
          var isVisible = (rect.top >= 0 && rect.bottom <= window.innerHeight);
          if (isVisible && !headline.classList.contains('headline-visible')) {
              headline.classList.add('headline-visible');
              startHeadlineAnimation(headline);
          }
      });
  }

  window.addEventListener('scroll', checkVisibility);
  checkVisibility();
});

